import { TemplateData, TemplateParams } from '.';

const openQuestionReview = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'courses',
  email: {
    buttonEnabled: true,
    buttonLink: '{{courseUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.tasksNewReviewContent}
      </p>
      <p>
        {{comment}}
      </p>
      <p>
        ${messages.tasksSeeCommentsAndReviews}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.tasksNewReviewSubject}`
  },
  placeholders: {
    comment: {
      label: messages.commonComment,
      example: 'Nicely done.'
    },
    courseTitle: {
      label: messages.coursesCourseTitle,
      example: 'Test course'
    },
    courseUrl: {
      label: messages.commonCourseLink,
      example: `${serverConfig.adminUrl}/courses/test-course/test-chapter`
    },
    user: {
      label: messages.commonUser,
      example: 'Bob Smith'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeOpenQuestionReview
});

export default openQuestionReview;
